import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21311" id="the-family-philosophy" className="bg-background text-foreground py-[120px] relative overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-4 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="mx-auto flex max-w-[800px] flex-col items-center text-center">
          <h2 className="font-sans text-[64px] leading-[1.1] font-bold tracking-tighter bg-gradient-to-r from-primary to-chart-2 bg-clip-text text-transparent">
            Every Patient is Family
          </h2>
          <p className="text-muted-foreground mt-8 mb-12 font-serif italic text-[21px] leading-relaxed">
            Our practice is built on three pillars: Empathy in every interaction, 
            the seamless Integration of advanced multidisciplinary care, and a 
            foundation of Trust. We treat your recovery with the same surgical 
            precision and personal devotion we would offer our own kin.
          </p>
          <Link to="/HealingPhilosophyPage">
            <Button variant="outline" className="bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-[1.02] h-auto rounded-full border-none px-8 py-3 text-sm font-medium tracking-widest uppercase transition-all duration-300">
              OUR HEALING PHILOSOPHY
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}